import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {

  public loading: boolean = true;
  public done: boolean = false;
  public error: boolean = false;
  public lead: any = {};
  public errors: any = [];
  public leadId: any;
  public buyer: any;

  constructor(
    private api: ApiService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.leadId = params['id'];

      this.api.getPrivacyFinance(this.leadId).subscribe(
        success => {
          this.buyer = success;
          this.loading = false;
        },
        error => {
          console.log(error);
          this.error = true;
          this.loading = false;
        });
    });
  }

  accept() {
    var error = false;
    this.buyer.privacies.map(privacy => {
      if (privacy.required) {
        if (!this.lead[privacy.paramName]) {
          error = true;
          this.errors[privacy.paramName] = true;
        } else {
          this.errors[privacy.paramName] = false;
        }
      }
    })

    if (!error) {
      this.api.putPrivacyFinance(this.leadId, this.lead).subscribe(
        success => {
          this.done = true;
        }, error => {
          console.log(error);
          this.error = true;
        }
      );
    }
  }

}
